import { Tooltip } from "@/components/common/ui/Tooltip";
import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils/cn";

export function AIGeneratedBadge({
  size = "md",
  reason,
}: {
  size?: "sm" | "md";
  reason?: string;
}) {
  const sizeClass = size === "sm" ? "w-4.5 h-4.5" : "w-4.5 h-4.5 inline";

  return (
    <Tooltip content={reason || "AI-Suggested"}>
      <Sparkles className={cn(sizeClass, "text-amber-400")} />
    </Tooltip>
  );
}
